import { render, staticRenderFns } from "./MetadataBlurb.vue?vue&type=template&id=55096546&"
import script from "./MetadataBlurb.vue?vue&type=script&lang=ts&"
export * from "./MetadataBlurb.vue?vue&type=script&lang=ts&"
import style0 from "./MetadataBlurb.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports